export const FLOW_SOURCE_STATISTICS_SET = "FLOW_SOURCE_STATISTICS_SET";
export const FLOW_NODES_STATISTICS_SET = "FLOW_NODES_STATISTICS_SET";
